import { useEffect } from 'react'
import { pushNotificationService } from '../../service/external/PushNotificationService'
import { useUser } from '../user/useUser'

export function usePushNotifications() {
  const { data: user } = useUser()

  // Register for push and add listeners once on mount
  useEffect(() => {
    pushNotificationService.initialize()
  }, [])

  // When user becomes available (after login or session restore), re-register so the device token
  // gets saved. The first registration often runs before auth is ready, so token was never stored.
  useEffect(() => {
    if (user?.id) {
      pushNotificationService.refreshToken()
    }
  }, [user?.id])
}
